var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45483 10.3599V5.32281C4.45506 4.98887 4.58788 4.66868 4.82409 4.43263C5.0603 4.19657 5.38058 4.06397 5.71452 4.06397H6.97336",
    stroke: "#DA291C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45483 7.84134H6.34352",
    stroke: "#DA291C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98627 10.3599V5.32282C8.98188 5.15471 9.01126 4.98742 9.07256 4.83084C9.13394 4.67425 9.22596 4.53153 9.34332 4.41108C9.46068 4.29064 9.601 4.19492 9.75593 4.12956C9.91086 4.0642 10.0773 4.03053 10.2455 4.03053C10.4137 4.03053 10.5801 4.0642 10.7351 4.12956C10.8901 4.19492 11.0304 4.29064 11.1477 4.41108C11.2651 4.53153 11.3571 4.67425 11.4185 4.83084C11.4798 4.98742 11.5092 5.15471 11.5048 5.32282V10.3599",
    stroke: "#DA291C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98608 7.84134H11.5046",
    stroke: "#DA291C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5419 9.10018C16.5462 9.26827 16.5169 9.43561 16.4555 9.59215C16.3942 9.74876 16.3021 9.89153 16.1848 10.0119C16.0674 10.1324 15.9272 10.2281 15.7722 10.2935C15.6172 10.3588 15.4507 10.3925 15.2826 10.3925C15.1145 10.3925 14.948 10.3588 14.793 10.2935C14.6381 10.2281 14.4978 10.1324 14.3804 10.0119C14.2631 9.89153 14.171 9.74876 14.1097 9.59215C14.0484 9.43561 14.019 9.26827 14.0234 9.10018V5.32282C14.019 5.15471 14.0484 4.98742 14.1097 4.83084C14.171 4.67425 14.2631 4.53153 14.3804 4.41108C14.4978 4.29064 14.6381 4.19492 14.793 4.12956C14.948 4.0642 15.1145 4.03053 15.2826 4.03053C15.4507 4.03053 15.6172 4.0642 15.7722 4.12956C15.9272 4.19492 16.0674 4.29064 16.1848 4.41108C16.3021 4.53153 16.3942 4.67425 16.4555 4.83084C16.5169 4.98742 16.5462 5.15471 16.5419 5.32282V9.10018Z",
    stroke: "#DA291C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.282 10.3598L16.5417 11.6187",
    stroke: "#DA291C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1101 1H1.88651C1.65109 1.00089 1.4256 1.09505 1.25944 1.26183C1.09329 1.42862 0.999998 1.65446 1 1.88989V13.3622C0.999998 13.5976 1.09329 13.8234 1.25944 13.9902C1.4256 14.157 1.65109 14.2511 1.88651 14.2521H3.94912C3.76354 15.2177 3.36365 16.1294 2.77893 16.92C5.35403 16.9572 6.98351 15.9609 7.96121 14.2521H19.1101C19.3461 14.2521 19.5724 14.1583 19.7394 13.9914C19.9063 13.8245 20 13.5982 20 13.3622V1.88989C20 1.65388 19.9063 1.42753 19.7394 1.26064C19.5724 1.09376 19.3461 1 19.1101 1Z",
    stroke: "#DA291C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.a6bba6f5d56c6a27578edc8439390034.svg";
export { ForwardRef as ReactComponent };